// View for displaying the SNFG representations of entries in the database as cards

import { Icon } from "semantic-ui-react";
import '../css/cardview.css';

// helper function from visualizer tool
import AutoSVG from "../visualizer-tool/automatic-svg/AutoSVG";
// helper function from databaseUtils
import databaseUtils from '../databaseUtils';

// components
import InfoCardModal from "./InfoCardModal";

export default function CardView({ data, handleEntryClick, selectedEntry, modalOpen, handleModalClose }) {

    function formatSpecies(species) {
        if (!species) return "";

        const words = species.trim().split(" ");
        if (words.length < 2) return words[0][0].toUpperCase();

        const firstInitial = words[0][0].toUpperCase();
        const secondInitial = words[1][0].toLowerCase();

        return `${firstInitial}${secondInitial}`;
    }  

    return (
        <div style={{overflowY:"auto", flex:'1 1 auto'}}>
            <div style={{display:"flex", flexWrap:"wrap", justifyContent:'space-around'}}>
                { 
                data.length === 0 ?
                        <div style={{ margin:"10vh"}}>
                            <Icon name='search' size='massive' color='grey'/>
                        </div>
                :
                    data.map((entry, index) => (
                    
                        <div className='organism-card ' key={index} onClick={() => handleEntryClick(entry)}>
                            <div className='card-header' style={{backgroundColor:databaseUtils.colourMap(entry.Species_where_found)}}>
                                <h3>{entry.Serotype} &emsp; <em>{formatSpecies(entry.Species_where_found)}</em> </h3> 
                            </div>
    
                            <div style={{ marginBottom:"0.vh"}}>
                                <AutoSVG casperString={entry.Antigen_structure === "" ? entry.Carbuilder_structure_format : entry.Antigen_structure}/>
                            </div>
                            
                        </div>
                    ))
                }
            </div>
            {selectedEntry && (
                <InfoCardModal
                    entry={selectedEntry}
                    open={modalOpen}
                    onClose={handleModalClose}
                />
            )}
        </div>
    )
}